import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@shopify/polaris'
import styled from 'styled-components'
import has from 'lodash/has'

import UICard from '../shopifyUI/UICard'
import ShopifyCrop from '../shopifyUI/ShopifyCrop'

const ContainerWithMargin = styled.div`
  margin: 1em
`
const FooterRight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const ButtonContainer = styled.div`
  margin-right: 1em
`

export default class BackgroundCropResize extends Component {

  constructor (props) {
    super(props)
    this.state = {
      loading: false
    }
  }

  renderRight () {
    const { onBack } = this.props
    const { loading } = this.state
    return (
      <FooterRight>
        <ButtonContainer>
          <Button onClick={onBack} size='slim'>
            Back
          </Button>
        </ButtonContainer>
        <Button loading={loading} primary onClick={this.apply} size='slim'>
          Done
        </Button>
      </FooterRight>
    )
  }

  apply = () => {
    const { loading } = this.state
    if (!loading) {
      this.setState({loading: true})
      this.shopifyCrop.getWrappedInstance().apply()
    }
  }

  onCropResizeDone = (path, url) => {
    console.log('onCropResizeDone', path, url)
    const { setShowcaseImage, onDone } = this.props
    setShowcaseImage(url)
    onDone()
  }

  shopifyCropMounted = ref => {
    this.shopifyCrop = ref
  }

  renderContent () {
    const { image, app } = this.props
    return (
      <ContainerWithMargin>
        <ShopifyCrop
          file={image}
          ref={this.shopifyCropMounted}
          path={[]}
          assets={has(app, 'assets') ? app.assets : {}}
          appId={app.id}
          previewEltId={'ou_showcase-image-preview'}
          onCropResizeDone={this.onCropResizeDone}
        />
      </ContainerWithMargin>
    )
  }

  render () {
    return (
      <UICard
        title={'Crop / Resize Image'}
        description={'Prevent stretching or image distortions on mobile.'}
        footerRight={this.renderRight()}
        content={this.renderContent()}
      />
    )
  }
}

BackgroundCropResize.propTypes = {
  app: PropTypes.object.isRequired,
  image: PropTypes.string,
  onBack: PropTypes.func.isRequired,
  setShowcaseImage: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/productsSlideWizard/BackgroundCropResize.js